var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisablededit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2728_8584",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2728_8584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 12.6666H4.26667L10.0167 6.91665L9.08333 5.98331L3.33333 11.7333V12.6666ZM12.8667 5.94998L10.0333 3.14998L10.9667 2.21665C11.2222 1.96109 11.5361 1.83331 11.9083 1.83331C12.2806 1.83331 12.5944 1.96109 12.85 2.21665L13.7833 3.14998C14.0389 3.40554 14.1722 3.71387 14.1833 4.07498C14.1944 4.43609 14.0722 4.74442 13.8167 4.99998L12.8667 5.94998ZM11.9 6.93331L4.83333 14H2V11.1666L9.06667 4.09998L11.9 6.93331Z",
    fill: "#DFE8F3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisablededit);
export default __webpack_public_path__ + "static/media/disablededit.676940529ad26967755bdd45cea9421d.svg";
export { ForwardRef as ReactComponent };